import { useNavigate, useSearchParams } from 'react-router-dom'
import { useUserContext } from '../../context/UserContext'
import { Stepper } from '../../components/Stepper'
import OnBoardingForm from './OnboardingForm'
import AdminProfile from '../../components/AdminProfile/AdminProfile'
import SaddlefitLogo from '../../assets/icons/logo.svg?react'

function OnBoarding() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const editMode = params.get('editMode') === 'true'
  const { isOpen, setIsOpen, stepperSteps } = useUserContext()
  const currentStep = 0

  const handleStepChange = stepIndex => {
    console.log({ stepIndex })
    if (stepIndex === 0) {
      navigate('/onboarding')
    } else if (stepIndex === 1) {
      navigate('/shopify-connect')
    } else if (stepIndex === 2) {
      navigate('/stripe-connect')
    }
  }

  const handleSkip = () => {
    let nextStep = currentStep

    while (
      nextStep < stepperSteps.length - 1 &&
      stepperSteps[nextStep + 1]?.isCompleted
    ) {
      nextStep += 1
    }

    if (
      nextStep === stepperSteps.length - 1 ||
      stepperSteps[nextStep + 1]?.isCompleted
    ) {
      navigate('/admin-dashboard')
    } else {
      handleStepChange(nextStep + 1)
    }
  }

  return (
    <div className="w-full h-screen flex">
      <div className="admin-dashboard-card-section mx-auto w-[100%]">
        <div className="w-[90%] md:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>

       {!editMode && <div className="w-[90%] md:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <Stepper
            steps={stepperSteps}
            currentStep={currentStep}
            onStepChange={handleStepChange}
            allowClickNavigation={true}
            showNavigation={false}
            className="mb-8"
          />
        </div>}

        <div className="w-[90%] md:w-[95%] pb-[50px] mt-[10px] h-[100%] mx-auto">
          <div className="w-full flex flex-col items-center mb-5 sm:mb-0 h-auto mt-10">
            {!editMode ? (
              <div className="flex flex-col sm:flex-row items-center justify-between max-w-[672px] w-full">
                <SaddlefitLogo />
                <span
                  className="text-[#2B364B] font-montserrat font-semibold hover:underline !w-auto cursor-pointer inline-flex items-center justify-center"
                  role="button"
                  onClick={handleSkip}
                >
                  Skip
                </span>
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row items-center justify-between max-w-[672px] w-full">
                <SaddlefitLogo />
              </div>
            )}
            <h1 className="admin-dashboard max-w-[672px] w-full">
              {editMode
                ? 'Update Business Information'
                : 'Business Information'}
            </h1>
            <OnBoardingForm onStepChange={handleStepChange} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OnBoarding
